import React from 'react';
import './App.css';
import { ThemeProvider, createTheme } from "@mui/material";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import FormulairePlaintes from './components/FormulairePlaintes';
import FormulaireRetraitPlaintes from './components/FormulaireRetraitPlainte';
import FormulaireCommunicationRenseignement from './components/FormulaireCommunicationRenseignement';
import FormulaireRenseignementsGeneraux from './components/FormulaireRenseignementsGeneraux';
import FormulaireAutorisationContracter from './components/FormulaireAutorisationContracter';
import REA from './components/REA';
import { AMPContainer } from './components/AMPContainer';
import { Confirmation } from './components/Confirmation/Confirmation';

const theme = createTheme({
  components: {
    // Name of the component
    MuiTextField: {
      defaultProps: {
        // The props to change the default for.
        variant: "filled",
      },
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          marginBottom: '1rem',
          //backgroundColor: '#f6f6f6',
        },
      },
    },
    MuiFilledInput: {
      defaultProps: {
        // The props to change the default for. 
      },
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          marginBottom: '0',
          //backgroundColor: '#f6f6f6',
        },
      },
    },
    MuiInput: {
      defaultProps: {
        // The props to change the default for. 
      },
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          marginBottom: '0',
         // backgroundColor: '#f6f6f6',
        },
      },
    },


  },
});

function App() {

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <AMPContainer>
          <BrowserRouter>
            <Routes>
              <Route path="/formuler-plainte" element={<FormulairePlaintes />} />
              <Route path="/retrait-plainte" element={<FormulaireRetraitPlaintes />} />
              <Route path="/communication-renseignement" element={<FormulaireCommunicationRenseignement />} />
              <Route path="/renseignements-generaux" element={<FormulaireRenseignementsGeneraux />} />
              <Route path="/autorisation-contracter" element={<FormulaireAutorisationContracter />} />
              <Route path="/confirmation" element={<Confirmation />} />
              <Route path="/rea" element={<REA />} />
            </Routes>
          </BrowserRouter>
        </AMPContainer>
      </ThemeProvider>
    </div>
  );
}


export default App;